/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryFull,
  CategoryFullOptional,
  CategoryFullMetaI,
  CategoryFullTrackedI,
} from "./category-full";
import { CategoryFullTracked, CategoryFullMeta } from "./category-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryType,
  CategoryTypeOptional,
  CategoryTypeMetaI,
  CategoryTypeTrackedI,
} from "./category-type";
import { CategoryTypeTracked, CategoryTypeMeta } from "./category-type";

/**
 *
 * @export
 * @interface CatalogCategoryDTO
 */
export interface CatalogCategoryDTOOptional extends CategoryFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogCategoryDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  categoryName?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  hidden?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  forReporting?: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CatalogCategoryDTO
   */
  categoryType?: CategoryType;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdBy?: string;
}

export interface CatalogCategoryDTO
  extends CatalogCategoryDTOOptional, CategoryFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogCategoryDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  categoryName: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  hidden?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  forReporting?: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CatalogCategoryDTO
   */
  categoryType?: CategoryType;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdBy?: string;
}

export interface CatalogCategoryDTOTrackedI extends CategoryFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogCategoryDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  categoryName?: string;
  categoryNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  description?: string;
  descriptionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  hidden?: boolean;
  hiddenIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogCategoryDTO
   */
  forReporting?: boolean;
  forReportingIsSet: boolean;
  /**
   *
   * @type {CategoryType}
   * @memberof CatalogCategoryDTO
   */
  categoryType?: CategoryType;
  categoryTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogCategoryDTO
   */
  createdBy?: string;
  createdByIsSet: boolean;
}

transformDatesMap.set(
  "CatalogCategoryDTO",
  function (model: CatalogCategoryDTO) {
    if (typeof model.updatedOn == "string")
      model.updatedOn = new Date(model.updatedOn);
    if (typeof model.createdOn == "string")
      model.createdOn = new Date(model.createdOn);
  },
);

export type CatalogCategoryDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  categoryName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  description: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  hidden: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  forReporting: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  categoryType: PropertyMeta<CategoryTypeMetaI>;
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CatalogCategoryDTOMeta: CatalogCategoryDTOMetaI =
  {} as CatalogCategoryDTOMetaI;
CatalogCategoryDTOMeta = typeMeta("CatalogCategoryDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  categoryName: propertyMeta(
    "categoryName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  description: propertyMeta(
    "description",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  hidden: propertyMeta("hidden", false, false, false, MetaTypesBase.boolean),
  forReporting: propertyMeta(
    "forReporting",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  categoryType: propertyMeta(
    "categoryType",
    false,
    false,
    false,
    CategoryTypeMeta,
  ),
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = CatalogCategoryDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CategoryFullMeta]);
  metaI.isDeleted.inheritedFrom = CategoryFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = CategoryFullMeta.isNew;
  metaI.assignId.inheritedFrom = CategoryFullMeta.assignId;
  metaI.tempID.inheritedFrom = CategoryFullMeta.tempID;
  metaI.categoryName.inheritedFrom = CategoryFullMeta.categoryName;
  metaI.description.inheritedFrom = CategoryFullMeta.description;
  metaI.hidden.inheritedFrom = CategoryFullMeta.hidden;
  metaI.forReporting.inheritedFrom = CategoryFullMeta.forReporting;
  metaI.categoryType.inheritedFrom = CategoryFullMeta.categoryType;
  metaI.updatedOn.inheritedFrom = CategoryFullMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = CategoryFullMeta.updatedBy;
  metaI.createdOn.inheritedFrom = CategoryFullMeta.createdOn;
  metaI.createdBy.inheritedFrom = CategoryFullMeta.createdBy;
});

export class CatalogCategoryDTOTracked
  extends CategoryFullTracked
  implements CatalogCategoryDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  categoryName__I?: string = undefined;
  categoryNameIsSet: boolean = false;
  set categoryName(v: undefined | string) {
    if (v !== undefined) {
      this.categoryName__I = v;
      this.categoryNameIsSet = true;
    } else {
      this.categoryName__I = v || undefined;
      this.categoryNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get categoryName() {
    return this.categoryName__I;
  }
  description__I?: string = undefined;
  descriptionIsSet: boolean = false;
  set description(v: undefined | string) {
    if (v !== undefined) {
      this.description__I = v;
      this.descriptionIsSet = true;
    } else {
      this.description__I = v || undefined;
      this.descriptionIsSet = true;
    }
    this.changeTracker = true;
  }
  get description() {
    return this.description__I;
  }
  hidden__I?: boolean = undefined;
  hiddenIsSet: boolean = false;
  set hidden(v: undefined | boolean) {
    if (v !== undefined) {
      this.hidden__I = v;
      this.hiddenIsSet = true;
    } else {
      this.hidden__I = v || undefined;
      this.hiddenIsSet = false;
    }
    this.changeTracker = true;
  }
  get hidden() {
    return this.hidden__I;
  }
  forReporting__I?: boolean = undefined;
  forReportingIsSet: boolean = false;
  set forReporting(v: undefined | boolean) {
    if (v !== undefined) {
      this.forReporting__I = v;
      this.forReportingIsSet = true;
    } else {
      this.forReporting__I = v || undefined;
      this.forReportingIsSet = false;
    }
    this.changeTracker = true;
  }
  get forReporting() {
    return this.forReporting__I;
  }
  categoryType__I?: CategoryType = undefined;
  categoryTypeIsSet: boolean = false;
  set categoryType(v: undefined | CategoryType) {
    if (v !== undefined) {
      this.categoryType__I = v;
      this.categoryTypeIsSet = true;
    } else {
      this.categoryType__I = v || undefined;
      this.categoryTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get categoryType() {
    return this.categoryType__I;
  }
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  constructor(config?: CatalogCategoryDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogCategoryDTOOptional,
    options?: AssignOptions,
  ): CatalogCategoryDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.categoryName &&
      this.categoryNameApplyFilter(optionsRequired.filter)
    ) {
      this.categoryName = config.categoryName;
      if (optionsRequired.unassign) this.categoryNameIsSet = false;
      else this.categoryNameIsSet = true;
    }
    if (
      config.description &&
      this.descriptionApplyFilter(optionsRequired.filter)
    ) {
      this.description = config.description;
      if (optionsRequired.unassign) this.descriptionIsSet = false;
      else this.descriptionIsSet = true;
    }
    if (config.hidden && this.hiddenApplyFilter(optionsRequired.filter)) {
      this.hidden = config.hidden;
      if (optionsRequired.unassign) this.hiddenIsSet = false;
      else this.hiddenIsSet = true;
    }
    if (
      config.forReporting &&
      this.forReportingApplyFilter(optionsRequired.filter)
    ) {
      this.forReporting = config.forReporting;
      if (optionsRequired.unassign) this.forReportingIsSet = false;
      else this.forReportingIsSet = true;
    }
    if (
      config.categoryType &&
      this.categoryTypeApplyFilter(optionsRequired.filter)
    ) {
      this.categoryType = config.categoryType;
      if (optionsRequired.unassign) this.categoryTypeIsSet = false;
      else this.categoryTypeIsSet = true;
    }
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogCategoryDTOTrackedI {
    const cloned = {} as CatalogCategoryDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.categoryNameIsSetDeep() &&
      this.categoryNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryNameIsSet = true;
      cloned.categoryName = this.categoryName;
    } else {
      //cloned.categoryNameIsSet = false
    }
    if (
      this.descriptionIsSetDeep() &&
      this.descriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.descriptionIsSet = true;
      cloned.description = this.description;
    } else {
      //cloned.descriptionIsSet = false
    }
    if (
      this.hiddenIsSetDeep() &&
      this.hiddenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.hiddenIsSet = true;
      cloned.hidden = this.hidden;
    } else {
      //cloned.hiddenIsSet = false
    }
    if (
      this.forReportingIsSetDeep() &&
      this.forReportingApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.forReportingIsSet = true;
      cloned.forReporting = this.forReporting;
    } else {
      //cloned.forReportingIsSet = false
    }
    if (
      this.categoryTypeIsSetDeep() &&
      this.categoryTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryTypeIsSet = true;
      cloned.categoryType = this.categoryType;
    } else {
      //cloned.categoryTypeIsSet = false
    }
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogCategoryDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.categoryNameApplyFilter(filter)) this.categoryNameIsSet = false;

    if (!this.descriptionApplyFilter(filter)) this.descriptionIsSet = false;

    if (!this.hiddenApplyFilter(filter)) this.hiddenIsSet = false;

    if (!this.forReportingApplyFilter(filter)) this.forReportingIsSet = false;

    if (!this.categoryTypeApplyFilter(filter)) this.categoryTypeIsSet = false;

    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.isDeleted,
      CatalogCategoryDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.isNew,
      CatalogCategoryDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.assignId,
      CatalogCategoryDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.tempID,
      CatalogCategoryDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  categoryNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.categoryName,
      CatalogCategoryDTOMeta,
      this.categoryName,
      this,
    );
  }
  categoryNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryNameIsSet && this.categoryNameApplyFilter(filter))
      return true;

    return false;
  }
  descriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.description,
      CatalogCategoryDTOMeta,
      this.description,
      this,
    );
  }
  descriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.descriptionIsSet && this.descriptionApplyFilter(filter))
      return true;

    return false;
  }
  hiddenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.hidden,
      CatalogCategoryDTOMeta,
      this.hidden,
      this,
    );
  }
  hiddenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.hiddenIsSet && this.hiddenApplyFilter(filter)) return true;

    return false;
  }
  forReportingApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.forReporting,
      CatalogCategoryDTOMeta,
      this.forReporting,
      this,
    );
  }
  forReportingIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.forReportingIsSet && this.forReportingApplyFilter(filter))
      return true;

    return false;
  }
  categoryTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.categoryType,
      CatalogCategoryDTOMeta,
      this.categoryType,
      this,
    );
  }
  categoryTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryTypeIsSet && this.categoryTypeApplyFilter(filter))
      return true;

    return false;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.updatedOn,
      CatalogCategoryDTOMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.updatedBy,
      CatalogCategoryDTOMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.createdOn,
      CatalogCategoryDTOMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogCategoryDTOMeta.createdBy,
      CatalogCategoryDTOMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.categoryNameIsSetDeep(filter)) return true;
    if (this.descriptionIsSetDeep(filter)) return true;
    if (this.hiddenIsSetDeep(filter)) return true;
    if (this.forReportingIsSetDeep(filter)) return true;
    if (this.categoryTypeIsSetDeep(filter)) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
